export class DocumentTypeFieldsMappingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDocumentTypes() {
    return this.#http.get('/DocumentTypeFieldsMapping');
  }

  async getMappingByDocumentTypeId({ documentTypeId }) {
    return this.#http.get(`/DocumentTypeFieldsMapping/${documentTypeId}`);
  }

  async createMapping(body) {
    return this.#http.post('/DocumentTypeFieldsMapping', body);
  }

  async updateMapping(body) {
    return this.#http.put('/DocumentTypeFieldsMapping', body);
  }

  async deleteMapping({ documentTypeId }) {
    return this.#http.delete(`/DocumentTypeFieldsMapping/${documentTypeId}`);
  }
}
